var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.25H4.25V0H0V4.25ZM6.375 17H10.625V12.75H6.375V17ZM0 17H4.25V12.75H0V17ZM0 10.625H4.25V6.375H0V10.625ZM6.375 10.625H10.625V6.375H6.375V10.625ZM12.75 0V4.25H17V0H12.75ZM6.375 4.25H10.625V0H6.375V4.25ZM12.75 10.625H17V6.375H12.75V10.625ZM12.75 17H17V12.75H12.75V17Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps-icon.da77e1a5cd1f6368bd6688598bf50a07.svg";
export { ForwardRef as ReactComponent };